import React from 'react';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import VerticalLayout from '../Layouts/VerticalLayouts';
import { allRoutesOfApplication } from './allRoutes';
import { AccessRoute } from './AuthProtected';
import { loginRequest } from '../authConfig';
import { SelectSearchValInStore } from '../Store/commonStore/selectors';

const Index = () => {
    const availablePublicRoutesPaths = allRoutesOfApplication.map((r) => r.path);
    // const allRolesData = useSelector((state) => SelectSearchValInStore(state, 'allRolesData'));

    return (
        <React.Fragment>
            <Route path={availablePublicRoutesPaths}>
                <Switch>
                    {allRoutesOfApplication.map((route, idx) => (
                        <AccessRoute path={route.path} component={route.component} key={idx} exact={true} />
                    ))}
                </Switch>
            </Route>
        </React.Fragment>
    );
};

export default Index;
